import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import { orderColumnsByType } from '../../config/kanban';

const OrderMenu = ({ orderMenu, handleClose, type, handleOrderClick, kanbanOrders }) => {
  const items = orderColumnsByType[type];

  return (
    <Menu
      id="basic-menu"
      anchorReference="anchorPosition"
      anchorPosition={
        Boolean(orderMenu.position) ? { top: orderMenu.position.mouseY, left: orderMenu.position.mouseX } : undefined
      }
      open={Boolean(orderMenu.position)}
      onClose={handleClose}
    >
      {items?.map((item) => {
        const selected = kanbanOrders?.some(
          (order) =>
            order.statusId === orderMenu.statusId && order.field === item.value && order.sort === orderMenu.order
        );

        return (
          <MenuItem key={item.value} onClick={() => handleOrderClick(item.value)}>
            <ListItemIcon sx={{ minWidth: 32 }}>{selected && <DoneIcon fontSize="small" />}</ListItemIcon>
            <ListItemText>{item.label}</ListItemText>
          </MenuItem>
        );
      })}
    </Menu>
  );
};

export default OrderMenu;
